var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -691,
    y: -639,
    width: 1440,
    height: 1500,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_606_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -389.939,
    y: -119.527,
    width: 1111,
    height: 77.5264,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_606_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -389.939,
    y: -20.1777,
    width: 350,
    height: 125,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_606_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 350,
    height: 125,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20.168,
    cy: 20,
    r: 20,
    fill: "#FFF7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2771 16.4988L16.0968 15.8447V15.3305C16.7281 14.8896 17.1129 14.1621 17.1129 13.3871V12.371C17.1129 11.0639 16.0493 10 14.7419 10C13.4346 10 12.371 11.0639 12.371 12.371V13.3871C12.371 14.1621 12.7558 14.89 13.3871 15.3305V15.8447L11.2068 16.4988C10.4851 16.7153 10 17.3673 10 18.1213V21.1774H12.603C12.456 21.486 12.371 21.8297 12.371 22.1935V23.2097C12.371 23.9847 12.7558 24.7125 13.3871 25.1531V25.6673L11.2068 26.3214C10.4851 26.5379 10 27.1898 10 27.9438V31H19.4839V27.9438C19.4839 27.1898 18.9988 26.5382 18.2771 26.3214L16.0968 25.6673V25.1531C16.7281 24.7122 17.1129 23.9847 17.1129 23.2097V22.1935C17.1129 21.8297 17.0279 21.486 16.8809 21.1774H19.4839V18.1213C19.4839 17.3673 18.9988 16.7153 18.2771 16.4988ZM16.4355 23.2097C16.4355 23.8105 16.111 24.3722 15.5884 24.6747L15.4194 24.7724V26.1714L18.0822 26.97C18.5155 27.1 18.8065 27.4917 18.8065 27.9438V30.3226H10.6774V27.9438C10.6774 27.4917 10.9683 27.1004 11.4016 26.9704L14.0645 26.1714V24.7724L13.8955 24.6747C13.3729 24.3722 13.0484 23.8105 13.0484 23.2097V22.1935C13.0484 21.2598 13.8082 20.5 14.7419 20.5C15.6757 20.5 16.4355 21.2598 16.4355 22.1935V23.2097ZM18.8065 20.5H16.3979C15.9701 20.0817 15.3858 19.8226 14.7419 19.8226C14.0787 19.8226 13.4792 20.097 13.0484 20.5375V20.5H10.6774V18.1213C10.6774 17.6691 10.9683 17.2778 11.4016 17.1478L14.0645 16.3488V14.9498L13.8955 14.8521C13.3729 14.5496 13.0484 13.9879 13.0484 13.3871V12.371C13.0484 11.4372 13.8082 10.6774 14.7419 10.6774C15.6757 10.6774 16.4355 11.4372 16.4355 12.371V13.3871C16.4355 13.9879 16.111 14.5496 15.5884 14.8521L15.4194 14.9498V16.3488L18.0822 17.1475C18.5155 17.2775 18.8065 17.6691 18.8065 18.1213V20.5Z",
    fill: "#FE8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0008 21.8548C31.0008 20.5663 30.4827 19.3979 29.646 18.5427V18.1213C29.646 17.3673 29.1609 16.7156 28.4392 16.4988L26.2589 15.8447V15.3305C26.8902 14.8896 27.275 14.1621 27.275 13.3871V12.371C27.275 11.0639 26.2114 10 24.904 10C23.5967 10 22.5331 11.0639 22.5331 12.371V13.3871C22.5331 14.1621 22.9179 14.89 23.5492 15.3305V15.8447L21.3689 16.4988C20.6472 16.7153 20.1621 17.3673 20.1621 18.1213V21.1774H21.5712C21.5389 21.3992 21.5169 21.6241 21.5169 21.8548C21.5169 23.9986 22.948 25.8124 24.904 26.397V27.2742H24.2266V27.9516H24.904V28.629H24.2266V29.3065H24.904V31H27.6137V29.3065H28.2911V28.629H27.6137V27.9516H28.2911V27.2742H27.6137V26.397C29.5697 25.8124 31.0008 23.9986 31.0008 21.8548ZM20.8395 20.5V18.1213C20.8395 17.6691 21.1304 17.2778 21.5638 17.1478L24.2266 16.3488V14.9498L24.0576 14.8521C23.535 14.5496 23.2105 13.9879 23.2105 13.3871V12.371C23.2105 11.4372 23.9703 10.6774 24.904 10.6774C25.8378 10.6774 26.5976 11.4372 26.5976 12.371V13.3871C26.5976 13.9879 26.2731 14.5496 25.7505 14.8521L25.5815 14.9498V16.3488L28.2443 17.1475C28.6247 17.2616 28.8955 17.5776 28.9557 17.959C28.1893 17.4268 27.2605 17.1129 26.2589 17.1129C24.1152 17.1129 22.3014 18.544 21.7167 20.5H20.8395ZM22.1944 21.8548C22.1944 19.6135 24.0176 17.7903 26.2589 17.7903C28.5002 17.7903 30.3234 19.6135 30.3234 21.8548C30.3234 24.0961 28.5002 25.9194 26.2589 25.9194C24.0176 25.9194 22.1944 24.0961 22.1944 21.8548ZM26.9363 30.3226H25.5815V29.3065H26.9363V30.3226ZM26.9363 28.629H25.5815V27.9516H26.9363V28.629ZM26.9363 27.2742H25.5815V26.5425C25.8032 26.5744 26.0282 26.5968 26.2589 26.5968C26.4896 26.5968 26.7145 26.5748 26.9363 26.5425V27.2742Z",
    fill: "#FE8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2411 22.7307L24.8032 22.2928L24.3242 22.7717L25.2411 23.6886L28.1903 20.7395L27.7113 20.2605L25.2411 22.7307Z",
    fill: "#FE8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.371 24.5002L27.9479 23.9711C27.4627 24.3593 26.8784 24.5645 26.2582 24.5645C24.7641 24.5645 23.5485 23.3489 23.5485 21.8548C23.5485 21.235 23.7538 20.6503 24.1422 20.1651L23.6132 19.7417C23.1278 20.349 22.8711 21.0795 22.8711 21.8548C22.8711 23.7225 24.3905 25.2419 26.2582 25.2419C27.0338 25.2419 27.7644 24.9852 28.371 24.5002Z",
    fill: "#FE8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2573 19.1451C27.7514 19.1451 28.967 20.3607 28.967 21.8548C28.967 22.4747 28.7618 23.0593 28.3733 23.5442L28.9023 23.9676C29.3878 23.3606 29.6444 22.6301 29.6444 21.8548C29.6444 19.9871 28.125 18.4677 26.2573 18.4677C25.4817 18.4677 24.7512 18.7244 24.1445 19.2095L24.5676 19.7385C25.0528 19.3504 25.6371 19.1451 26.2573 19.1451Z",
    fill: "#FE8700"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -690.5,
    y: -638.5,
    width: 1439,
    height: 1499,
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_606_2",
    x: -437.939,
    y: -165.527,
    width: 1207,
    height: 173.526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_606_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_606_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_606_2",
    x: -437.939,
    y: -66.1777,
    width: 446,
    height: 221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_606_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_606_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_606_2",
    x: -68,
    y: -66,
    width: 446,
    height: 221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_606_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_606_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -691,
    y: -639,
    width: 1440,
    height: 1500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreselected);
export default __webpack_public_path__ + "static/media/Preselected.0e1f5d225d6b0ffec8f58410efdd154e.svg";
export { ForwardRef as ReactComponent };